import React from "react"
import PromoSoonOverHandler from "../components/PromoSoonOverHandler"

const Confirm: React.FC = () => {
	return (
		<PromoSoonOverHandler>
			<div className="relative ">
				<picture>
					<source media="(min-width: 768px)" srcSet={"/images/danke-desktop.jpg"} />
					<img src={"/images/danke-mobile.jpg"} className=" block w-full" alt="Danke" />
				</picture>
			</div>
			<div className="text-center pt-4 sm:pt-0">
				<h2 className="h2 text-yellow font-Fields text-[30px] sm:text-[49px] max-w-[805px] mx-auto leading-tight">
					Deine Daten wurden erfolgreich übermittelt
				</h2>
				<p className="font-AcuminWide text-[14px] sm:text-[24px] mt-4 max-w-[905px] mx-auto px-4">
					Du erhältst von uns per E-Mail eine Eingangsbestätigung. Anschließend werden wir die Einhaltung der
					Teilnahmevoraussetzungen prüfen.
					<br />
					<br />
					Viele Grüße
					<br />
					Dein Wilkinson Team
				</p>

				<div className="pb-20 sm:pb-12 pt-12 text-center">
					<a href="/" className="btn btn-yellow">
						Zurück zur Aktion
					</a>
				</div>
			</div>
		</PromoSoonOverHandler>
	)
}
export default Confirm
